import {
  listSiteScripts as publicListSiteScripts,
  getEssentialProperties as publicGetEssentialProperties,
  getSiteMetadata as publicGetSiteMetadata,
} from './assets-v1-site-script-scripts.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const listSiteScripts: MaybeContext<
  BuildRESTFunction<typeof publicListSiteScripts> & typeof publicListSiteScripts
> = /*#__PURE__*/ createRESTModule(publicListSiteScripts);
export const getEssentialProperties: MaybeContext<
  BuildRESTFunction<typeof publicGetEssentialProperties> &
    typeof publicGetEssentialProperties
> = /*#__PURE__*/ createRESTModule(publicGetEssentialProperties);
export const getSiteMetadata: MaybeContext<
  BuildRESTFunction<typeof publicGetSiteMetadata> & typeof publicGetSiteMetadata
> = /*#__PURE__*/ createRESTModule(publicGetSiteMetadata);

export {
  PositionOnPage,
  ResolutionMethod,
} from './assets-v1-site-script-scripts.universal.js';
export {
  SiteScript,
  ListSiteScriptsRequest,
  ListSiteScriptsResponse,
  GetEssentialPropertiesRequest,
  GetEssentialPropertiesResponse,
  EssentialProperties,
  Locale,
  Multilingual,
  SupportedLanguage,
  GetSiteMetadataRequest,
  GetSiteMetadataResponse,
  ListSiteScriptsOptions,
  GetSiteMetadataOptions,
} from './assets-v1-site-script-scripts.universal.js';
export {
  PositionOnPageWithLiterals,
  ResolutionMethodWithLiterals,
} from './assets-v1-site-script-scripts.universal.js';
